import React from 'react';

const Message = ({ text, ...props }) => (
  <div className="message" {...props}>
    <div>{text}</div>
  </div>
);

export default Message;
